const orderTrack = {
    template: '',
    error: function (data) {
        if (!data.responseJSON._ajax_exception)
            data.responseJSON._ajax_exception = 'Backend call Error';
        notification.warning(data.responseJSON._ajax_exception)
    },
    setupFilter: function (displayMenu) {
        let me = this;
        $('#saveNewFilter').click(function () {
            let name = $('#newFilterName').val();
            if (!name)
                return notification.warning(output.e_folgende_felder_mussen_befult_werden + ': ' + output.t_name)

            orderTrack.saveFilter(name)
        })

        $("#filterList").on('click', '.fa-btn', function (event) {

            const dataKey = $(this).closest('li.list-group-item').data('key');

            if ($(this).hasClass('fa-star-o')) {
                me.setDefault(dataKey);
            } else if ($(this).hasClass('fa-star')) {
                me.removeDefault(dataKey)
            } else if ($(this).hasClass('fa-check')) {
                me.loadFilter(dataKey)
            } else if ($(this).hasClass('fa-trash')) {
                me.deleteFilter(dataKey)
            }
        });

        const el = $('#filterList').first()
        this.template = el.html();
        el.html('');
        this.populateList(displayMenu)
    },
    populateList: function (displayMenu) {
        AjaxHandlerByClass('ajax/OrderTrack/SearchFilter/getFilters',
            {displaymenu: displayMenu},
            function (data) {
                $.each(data, function (index, value) {
                    if (index == 'debug') return;
                    orderTrack.addFilterOption(value)
                    if (value.default == 1) {
                        let element = $('li[data-key="' + value.id + '"]');
                        element.find('.fa-star').removeClass('hidden');
                        element.find('.fa-star-o').addClass('hidden');
                    }
                });
            }, this.error);
    },
    submitOrdertrackRememberForm: function (offset) {
        orderTrack.setOrdertrackRememberForm(offset);
        document.ordertrackfilter_remember.submit();
    },
    expand: function (prefix) {
        if (typeof prefix == 'undefined')
            prefix = '';
        setVal4AllEqualFormElems(prefix + 'extendedFilter', 'Y');
        hideElem(document.getElementById(prefix + 'button_expand_filter'));
        showElem(document.getElementById(prefix + 'button_collapse_filter'));
        showElemAndShowChilds(document.getElementById(prefix + 'extended_filter'))
    },
    colapse: function (prefix) {
        if (typeof prefix == 'undefined')
            prefix = '';
        setVal4AllEqualFormElems(prefix + 'extendedFilter', 'N');
        hideElem(document.getElementById(prefix + 'button_collapse_filter'));
        showElem(document.getElementById(prefix + 'button_expand_filter'));
        hideElem(document.getElementById(prefix + 'extended_filter'));
    },
    addFilterOption: function (values) {
        var htmlTemplate = orderTrack.template;

        if (values.msg)
            notification.info(values.msg);

        for (const prop in values) {
            if (values.hasOwnProperty(prop)) {
                htmlTemplate = htmlTemplate.replace('!' + prop, values[prop]);
            }
        }
        $('#filterList').append(htmlTemplate);
    },
    saveFilter(val) {
        orderTrack.setOrdertrackRememberForm();
        const data = {};
        const ignore = [
            'sid', 'form_submited', 'jumpto', 'remember_pending_to_date', 'jumpto',
            'remember_pending_from_date', 'remember_to_date', 'remember_from_date'
        ]
        $.map($('#orderTrackFilterRemember').serializeArray(), function (n, i) {
            if (!ignore.includes(n['name']))
                data[n['name']] = n['value'];
        });
        data['save_name'] = val;
        AjaxHandlerByClass('ajax/OrderTrack/SearchFilter/saveFilter', data, this.addFilterOption, this.error);
    },
    setDefault: function (dataKey) {
        AjaxHandlerByClass('ajax/OrderTrack/SearchFilter/setDefault', {id: dataKey}, function (data) {

            if (data && data.msg)
                notification.info(data.msg);

            let filterList = $('#filterList');
            let item = $(`li[data-key="${dataKey}"]`);

            filterList.find('.fa-star-o').removeClass('hidden')
            filterList.find('.fa-star').addClass('hidden')
            item.find('.fa-star-o').addClass('hidden')
            item.find('.fa-star').removeClass('hidden')
        }, this.error);
    },
    removeDefault: function (dataKey) {
        AjaxHandlerByClass('ajax/OrderTrack/SearchFilter/setDefault', {remove: true}, function (data) {

            if (data && data.msg)
                notification.info(data.msg);
            let element = $('li[data-key="' + dataKey + '"]');
            element.find('.fa-star-o').removeClass('hidden');
            element.find('.fa-star').addClass('hidden');
        }, this.error);
    },
    loadFilter: function (dataKey) {
        notification.info(output.t_wird_geladen);
        AjaxHandlerByClass('ajax/OrderTrack/SearchFilter/loadFilter', {id: dataKey}, function (data) {

            for (const prop in data) {
                if (data.hasOwnProperty(prop)) {

                    if (!document.ordertrackfilter_remember[prop])
                        continue;
                    document.ordertrackfilter_remember[prop].value = data[prop];
                    console.log({
                        name: prop,
                        set: document.ordertrackfilter_remember[prop].value,
                        new: data[prop]
                    })
                }
            }
            document.ordertrackfilter_remember.jumpto.value = '';
            document.ordertrackfilter_remember.submit();
        }, this.error);
    },
    deleteFilter: function (dataKey) {
        notification.info(output.t_wird_geladen);
        AjaxHandlerByClass('ajax/OrderTrack/SearchFilter/deleteFilter', {id: dataKey}, function () {
            $('li.list-group-item[data-key="' + dataKey + '"]').remove();
        }, this.error);
    }
};